import React from "react";
// Wrapper for back.svg image created for fill and stoke color dynamically set
const ChevronDownIcon = props => {
    const {width, height, fill} = props
    return (
        <svg width={width} height={height} viewBox="0 0 120 120" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <title>chevron_down</title>
            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="Assets_icone" transform="translate(-1793.000000, -6360.000000)" fill={fill}>
                    <g id="chevron_down" transform="translate(1793.000000, 6360.000000)">
                        <g id="espanso" transform="translate(3.461538, 31.038462)">
                            <path d="M56.5384615,62.4230769 C55.062,62.4230769 53.5855385,61.8598846 52.4590385,60.7332692 L1.68980769,9.96403846 C-0.563192308,7.71103846 -0.563192308,4.05807692 1.68980769,1.80507692 C3.94292308,-0.447923077 7.59565385,-0.447923077 9.84876923,1.80507692 L56.5384615,48.495 L103.228154,1.80519231 C105.481385,-0.447807692 109.134,-0.447807692 111.387115,1.80519231 C113.64,4.05819231 113.64,7.71115385 111.387115,9.96415385 L60.6178846,60.7333846 C59.4913846,61.8598846 58.0149231,62.4230769 56.5384615,62.4230769 Z" id="Path"></path>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    )
}
export default ChevronDownIcon